import React from "react";

const InputLabelLight = ({ label }) => {
    return <p className={"font-light font-poppins text-sm pb-1"}>{label}</p>;
};

export default InputLabelLight;
